module.exports = __webpack_public_path__ + "static/media/tab-puffs-creamy.d010869a.png";